import { SAColumns, SAIcon, SAIcons, SAIconSize } from "@saux/design-system-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import disable_send_icon from "../../icons/Group.png";
import enable_send_icon from "../../icons/SendMessage.png";
import template_icon from "../../icons/Template.png";
import upload_icon from "../../icons/Upload.png";
import { updateCustomerDetails, updateMessagesById } from "../../store/action-creators/conversationActionCreator";
import {
  addParticipant,
  createConversation,
  createMessage,
  fetchCustomerDetails,
  formatSelectedConversation,
  updateReadMessages,
} from "../../store/actions/conversationActions";
import {
  ADJUSTER,
  CONVERSATION,
  CUSTOMER,
  INACTIVE,
  NEW,
  OPT_IN_MESSAGES,
  OPT_OUT_MESSAGE,
  OPT_OUT_MESSAGES,
  SNACKBAR,
  STATE_AUTO_INSURANCE,
} from "../../utils/constants";
import ChatContentItem from "../chatContentItem/ChatContentItem";
import Participants from "../participants/Participants";
import AutomatedMessagesTemplate from "../automatedMessagesTemplate/AutomatedMessagesTemplate";
import {
  checkAllParamsRequestedFromCC,
  formatNewLinesInHtml,
  formatPhoneNumber,
  isNotEmpty,
  simpleGTMDataLayer,
} from "../../utils/utilities";
import TextArea from "../textarea/TextArea";
import { isEmpty } from "lodash";
import CollectionsIcon from "@material-ui/icons/Collections";
import "./ChatContent.css";
import ImageViewer from "../ImageViewer/ImageViewer";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { executeGraphqlQuery } from "../../graphql/api";
import { loader } from "graphql.macro";
import { useLocation } from "react-router-dom";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { isReturnStatement } from "typescript";
import { grey } from "@material-ui/core/colors";
import claimSearch from "../../store/actions/claimsSearchActions";

const LoaderModal = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;

const getImagesByConversation = loader(
  "../../graphql/queries/getImagesByConversation.graphql"
);

export interface ImageDetails {
  conversationId: string;
  contentType: string;
  message: string;
  createdTimestamp: string;
  messageId: string;
}

export default function ChatContent(props: any) {
  const [uploadImages, setUploadImages] = useState<any[]>([]);
  const [newMessage, setNewMessage] = useState("");
  const [gallery, setgallery] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isFreezed, setFreezed] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [
    selectedConversationMessages,
    setSelectedConversationMessages,
  ] = useState<any>([]);
  const [uniqueData, setUniqueData] = useState<string[]>([]);
  const [preview, setPreview] = useState(false);
  const [imageData, setImageData] = useState<ImageDetails[]>([]);
  const messages = useSelector((state: any) => state.chat.messagesById);
  const user = useSelector((state: any) => state.user);
  const unreadMsgCount = useSelector((state: any) => state.chat.unreadMsgCount);
  const loader = useSelector((state: any) => state.loader.messagesLoader);
  const selectedConversation = useSelector(
    (state: any) => state.chat.selectedConversation
  );
  let customer =
    selectedConversation?.participants &&
    selectedConversation?.participants.find(
      (con: any) => con.participantType === CUSTOMER
    );
  let participants = useSelector(
    (state: any) => state.chat.participants
  );
  const dispatch = useDispatch();
  const messagesEndRef = useRef<HTMLInputElement>(null);

  //let location = useLocation();
  const query = new URLSearchParams(window?.location?.search);
  const variable = { conversationId: query.get("id") };

  useEffect(() => {
    setSelectedConversationMessages(
      messages[selectedConversation?.conversationId] || []
    );
  }, [messages, selectedConversation]);

  useEffect(() => {
    setNewMessage("");
    setUploadImages([]);
  }, [selectedConversation]);

  useEffect(() => {
    scrollToBottom();
    let textMessages = [...selectedConversationMessages];
    let optOutMessageIndex = textMessages
      .reverse()
      .findIndex((message: any) =>
        OPT_OUT_MESSAGES.includes(message.message.trim().toUpperCase())
      );
    let optInMessageIndex = textMessages.findIndex((message: any) =>
      OPT_IN_MESSAGES.includes(message.message.trim().toUpperCase())
    );
    if (
      (optOutMessageIndex !== -1 && optInMessageIndex === -1) ||
      (optInMessageIndex > -1 &&
        optOutMessageIndex > -1 &&
        optOutMessageIndex < optInMessageIndex)
    ) {
      setFreezed(true);
    } else {
      setFreezed(false);
    }
  }, [selectedConversationMessages]);

  const scrollToBottom = () => {
    if (messagesEndRef && messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  };

  const sendOptOutMessage = (conversation: any) => {
    let messagesInput: any[] = [];
    if (uploadImages.length > 0) {
      uploadImages.map((img) => {
        messagesInput.push({
          adjusterId: user.email,
          author: user.fullName,
          claimNumber: selectedConversation.claimNumber,
          conversationId: conversation.conversationId,
          message: addAdjusterSignature(OPT_OUT_MESSAGE),
          mediaBase64: img.mediaBase64,
          contentType: img.type
        });
      });
    }
    else {
      messagesInput.push({
        adjusterId: user.email,
        author: user.fullName,
        claimNumber: selectedConversation.claimNumber,
        conversationId: conversation.conversationId,
        message: addAdjusterSignature(OPT_OUT_MESSAGE),
      });
    }
    setUploadImages([]);

    dispatch(
      createMessage(messagesInput, (res: any) => {
        dispatch(formatSelectedConversation(conversation));
      })
    );
  };

  const sendUWCompanyMessage = (conversation?: any) => {
    if (selectedConversation.uwCompany !== undefined) {
      let messagesInput: any[] = [];

      messagesInput.push({
        adjusterId: user.email,
        author: user.fullName,
        claimNumber: selectedConversation.claimNumber,
        conversationId: conversation.conversationId,
        message: addAdjusterSignature(`Policy underwritten by ${selectedConversation.uwCompany}`),
      });

      setUploadImages([]);

      dispatch(
        createMessage(messagesInput, (res: any) => {
          dispatch(formatSelectedConversation(conversation));
        })
      );
    }
  };

  const sendMessage = (conversation?: any) => {
    let messagesInput: any[] = [];
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Send-Message-Click`,
      event_action: "Button Click",
      event_category: window.location.pathname,
      event_label: `Sending message in a conversation.`,
      event_value: `${user.fullName} triggered send message event in a conversation with claim number ${selectedConversation.claimNumber}.`,
      claim_number: selectedConversation.claimNumber,
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Send-Message-Click-Snowplow`,
      event_action: "Button Click",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Sending message in a conversation.`,
      event_value: `${user.fullName} triggered send message event in a conversation with claim number ${selectedConversation.claimNumber}.`,
      claim_number: selectedConversation.claimNumber,
    });
    if (uploadImages.length > 0) {
      uploadImages.map((img) => {
        messagesInput.push({
          adjusterId: user.email,
          author: user.fullName,
          claimNumber: selectedConversation.claimNumber,
          conversationId:
            selectedConversation.conversationId === NEW
              ? conversation.conversationId
              : selectedConversation.conversationId,
          message: addAdjusterSignature(newMessage),
          mediaBase64: img.mediaBase64,
          contentType: img.type
        });
      })

    }
    else {
      messagesInput.push({
        adjusterId: user.email,
        author: user.fullName,
        claimNumber: selectedConversation.claimNumber,
        conversationId:
          selectedConversation.conversationId === NEW
            ? conversation.conversationId
            : selectedConversation.conversationId,
        message: addAdjusterSignature(newMessage),
      });
    }
    setUploadImages([]);

    dispatch(
      createMessage(messagesInput, (res: any) => {
        if (selectedConversation.conversationId === NEW) {
          sendOptOutMessage(conversation);
          sendUWCompanyMessage(conversation);
        }
      })
    );
  };

  const createNewConversation = () => {
    const create_conversation = {
      adjusterId: user.email,
      adjusterName: user.fullName,
      claimNumber: selectedConversation.claimNumber,
      friendlyName: CONVERSATION + " " + selectedConversation.claimNumber,
      phoneNumber: selectedConversation?.participants[0].phoneNumber,
      customerName: selectedConversation?.participants[0].name,
      contactId: selectedConversation?.participants[0].contactId,
      adjusterPhoneNumber: selectedConversation?.textNumber,
      env: selectedConversation?.env,
    };
    dispatch(
      createConversation(create_conversation, (res: any) => {
        let newConversation = res;
        sendMessage(newConversation);
      })
    );
  };

  const addNewParticipantOrSendMessage = () => {
    //check adjuster is in participants or not.
    let isParticipant = (selectedConversation.participants || []).find(
      (participant: any) => participant.adjusterId === user.email
    );
    if (!isParticipant || isParticipant.participantStatus === INACTIVE) {
      const add_participant = {
        conversationId: selectedConversation.conversationId,
        claimNumber: selectedConversation.claimNumber,
        participantName: user.fullName,
        adjusterId: user.email,
        participantType: ADJUSTER,
        reJoin: isParticipant ? true : false,
      };
      dispatch(
        addParticipant(add_participant, (res: any) => {
          // dispatch(fetchParticipants(selectedConversation.conversationId));
          sendMessage();
        })
      );
    } else {
      //already a participant
      sendMessage();
    }
  };

  const addAdjusterSignature = (message: string) => {
    return message + "\n- " + user.fullName + ", " + STATE_AUTO_INSURANCE;
  };

  const messageUpload = () => {
    if (newMessage || uploadImages.length > 0) {
      let messagePayload: any[] = [];
      setDialogOpen(false);
      if (uploadImages.length > 0) {
        uploadImages.map((img) => {
          messagePayload.push({
            message: formatNewLinesInHtml(addAdjusterSignature(newMessage)),
            mediaBase64: img.mediaBase64,
            createdTime: new Date(),
            from: {
              id: user.email,
              name: user.fullName,
            },
            pending: true,
            contentType: img.type
          });
        });
      }
      else {
        messagePayload.push({
          message: formatNewLinesInHtml(addAdjusterSignature(newMessage)),
          createdTime: new Date(),
          from: {
            id: user.email,
            name: user.fullName,
          },
          pending: true,
        });
      }

      dispatch(
        updateMessagesById({
          [selectedConversation.conversationId]: [
            ...selectedConversationMessages,
            ...messagePayload,
          ],
        })
      );
      setNewMessage("");

      if (selectedConversation.conversationId === NEW) {
        createNewConversation();
      } else {
        addNewParticipantOrSendMessage();
      }
    }
  };

  const onChangeInputMsg = (e: any) => {
    setNewMessage(e.target.value);
    if (isEmpty(newMessage) && selectedConversation?.conversationId !== NEW) {
      dispatch(
        updateReadMessages({
          conversationId: selectedConversation?.conversationId,
          adjusterId: user.email,
        })
      );
    }
  };

  const openAutomatedModal = async () => {
    let convoId: any = selectedConversation?.conversationId === NEW ? null : selectedConversation?.conversationId;
    if(selectedConversation?.conversationId !== NEW) {
      dispatch(fetchCustomerDetails(selectedConversation.claimNumber, customer.contactId, convoId));
    }
     else{
          const sessionResponse = sessionStorage.getItem('newConvoCutomer');
          let response: any = JSON.parse(sessionResponse || "{}");
          if(Object.keys(response).length !== 0){
            dispatch(updateCustomerDetails(response));
          }
          else{
            dispatch(fetchCustomerDetails(selectedConversation.claimNumber, customer.contactId, convoId));
          }
     }
    setDialogOpen(true);
  }


  const getImageData = () => {
    setSpinner(true);

    executeGraphqlQuery(getImagesByConversation, variable)
      .then((res: any) => {
        const conversationsResponse: ImageDetails[] =
          res.data.getImagesByConversation;

        if (conversationsResponse.length > 0) {
          setImageData(conversationsResponse);
          setgallery(true);

          setUniqueData([
            ...Array.from(
              new Set(
                conversationsResponse.map((item) =>
                  item.createdTimestamp.slice(0, 10)
                )
              )
            ),
          ]);
          setSpinner(false);
        } else {
          setSpinner(false);
          setgallery(false);
          dispatch(
            snackbarOpen({
              open: true,
              message: "No Images found",
              type: SNACKBAR.ERROR,
            })
          );
        }
      })
      .catch((error) => {
        setSpinner(false);
        console.log(error.message);
        dispatch(
          snackbarOpen({
            open: true,
            message: "Something went wrong",
            type: SNACKBAR.ERROR,
          })
        );
      });
  };

  //Convert to base64
  const getBase64 = (file: any) => {
    console.log(file);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = error => reject(error);
    });
  }

  //Remove image from message bar.
  const RemoveImage = (e: React.MouseEvent<HTMLElement>, img: any) => {
    e.preventDefault();
    const files = uploadImages.filter((file: any) => { return file.name !== img.name });
    setUploadImages(files);
  }

  //add multiple images
  const addImages = (e: any | null) => {
    e.preventDefault();
    let file: any[] = [];
    file = e.target.files;
    let imageExist: any[] = [];
    //Check file already exist or not
    uploadImages.filter((item: any) => {
      file = Object.values(file).filter((image: any) => {
        if (item.name === image.name) {
          imageExist.push(image.name);
        }
        else {
          return image;
        }
      });
    });
    const fileTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif"];
    let error: boolean = false;
    let errorMessage: any = [];
    let notAllowedFileTypes: any[] = [];
    let sizeExidedFiles: any[] = [];
    //Check file type
    file = Object.values(file).filter((val: any) => {
      if (!fileTypes.includes(val.type.toLowerCase())) {
        notAllowedFileTypes.push(val.type);
      }
      else {
        return val;
      }
    });
    //File size validation
    file = Object.values(file).filter((val: any) => {
      if (val.size >= 5242880) {
        sizeExidedFiles.push(val.name);
      }
      else {
        return val;
      }
    });

    if (notAllowedFileTypes.length > 0) {
      error = true;
      errorMessage.push(`${notAllowedFileTypes.join()} file type not accepted.`);
    }
    if (imageExist.length > 0) {
      error = true;
      errorMessage.push(`${imageExist.join()} already exist.`);
    }
    if (sizeExidedFiles.length > 0) {
      error = true;
      errorMessage.push(`${sizeExidedFiles.join()} file size exceeds maximum limit 5 MB.`);
    }
    if ((uploadImages.length + file.length) > 5) {
      error = true;
      errorMessage = [];
      errorMessage.push(`Maximum 5 files allowed to upload`);
      file = [];
    }

    let imageFiles: any = [];
    if (file.length > 0) {
      file.map((image) => {
        getBase64(image).then((data: any) => {
          const base64 = data
            .replace('data:', '')
            .replace(/^.+,/, '');
          image['mediaBase64'] = base64;
          imageFiles.push(image);
          setUploadImages([...uploadImages, ...imageFiles]);
        });
      });

      //Snowplow tag
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Upload-Image-Icon-Click`,
        event_action: 'Button Click',
        event_category: window.location.pathname,
        event_label: `Upload Image Icon`,
        event_value: `${user.fullName} clicked on 'Upload Image' icon.`
      });
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Upload-Image-Icon-Click-Snowplow`,
        event_action: 'Button Click',
        event_category: window.location.pathname + "/Snowplow",
        event_label: `Upload Image Icon`,
        event_value: `${user.fullName} clicked on 'Upload Image' icon.`
      });
    }
    if (error) {
      dispatch(
        snackbarOpen({
          open: true,
          message: errorMessage.join(),
          type: SNACKBAR.ERROR,
        })
      );
    }
  }

  //To fix - when user second time select same file for upload onchange event should trigger
  const handleClick = (e: any | null) => {
    const { target = {} } = e || {};
    target.value = "";
  }

  return (
    <>
      {spinner && (
        <LoaderModal>
          <Grid container alignItems="center" style={{ height: "80vh" }}>
            <Grid
              container
              justify="flex-end"
              direction="row"
              alignItems="center"
            >
              <Grid item xs={12}>
                <div className="loader" />
              </Grid>
            </Grid>
          </Grid>
        </LoaderModal>
      )}

      <div className="main-chatcontent" data-testid="chat-content">
        <div className="content-header" style={{ position: "relative" }}>
          {isNotEmpty(selectedConversation) && <Participants />}

          <div
            id="automated-modal"
            style={{ position: "absolute", left: "95%", top: "5%" }}
            data-testid="automated-modal"
            onClick={getImageData}
          >
            <CollectionsIcon />
          </div>
        </div>
        <div className="message-body" ref={messagesEndRef}>
          {loader.isLoading ? (
            <div className="loader" />
          ) : (
            selectedConversationMessages.map((item: any, index: any) => {
              let unreadIndex =
                selectedConversationMessages.length -
                unreadMsgCount[selectedConversation?.conversationId];
              return (
                <ChatContentItem
                  animationDelay={index + 2}
                  item={item}
                  key={index}
                  scrollToBottom={scrollToBottom}
                  unread={index === unreadIndex}
                  customer={customer}
                  imageData={imageData}
                  uniqueData={uniqueData}
                  setSpinner={setSpinner}
                />
              );
            })
          )}
        </div>

        {isNotEmpty(selectedConversation) && !props.readOnly && (
          <div className="content-footer" data-testid="content-footer">
            <div className={`sendNewMessage ${isFreezed ? "disable" : ""}`}>
              <SAColumns columns={{ lg: [10, 2], md: [9, 3], sm: [6, 6] }}>
                {uploadImages.length === 0 ? <TextArea
                  value={newMessage}
                  data-testid="message-Input"
                  onEnter={messageUpload}
                  onChange={onChangeInputMsg}
                  spellCheck={true}
                  disabled={isFreezed}
                  placeholder={
                    isFreezed ? `Chat Closed` : `Message ${customer?.name}`
                  }
                /> :

                  <div >
                    {uploadImages.map((img) => {
                      return (<div style={{
                        display: "flex", float: "left", borderRadius: 5, backgroundColor: "aliceblue",
                        margin: 10, padding: 5, border: "solid 1px lightgray"
                      }}><SAIcon
                          style={{ width: "auto", border: "solid 1px grey", padding: 7, backgroundColor: "#FF0099", borderRadius: 5 }}
                          icon={SAIcons.x} size={SAIconSize.small} colorVariant="dark" onClick={(e: React.MouseEvent<HTMLElement>) => { RemoveImage(e, img) }} />
                        <label style={{
                          alignItems: "center",
                          justifyContent: "center",
                          alignSelf: "center", padding: 7, fontFamily: "PT Sans"
                        }}>{img.name}</label></div>)
                    })}

                  </div>
                }
                {!isFreezed && (
                  <div
                    style={{ display: "flex", float: "right", height: "100%" }}
                  >
                    <div id="upload-image" data-testid="upload-image">
                      <input type="file" multiple style={{ display: "none" }} id="contained-button-file" onInput={(e
                        : any | null) => addImages(e)} onClick={handleClick} />
                      <label htmlFor="contained-button-file">
                        <img
                          style={{cursor:"pointer"}}
                          src={upload_icon}
                          alt="upload-img"
                          width={19}
                          height={19}
                        ></img>
                      </label>
                    </div>
                    <div
                      id="automated-modal"
                      data-testid="modal"
                      onClick={() => openAutomatedModal()}
                    >
                      <img
                        src={template_icon}
                        alt="#"
                        width={18}
                        height={18}
                      ></img>
                    </div>
                    <div
                      id="sendButton"
                      data-testid="sendButton"
                      onClick={messageUpload}
                    >
                      <img
                        src={
                          newMessage.length > 0
                            ? enable_send_icon : uploadImages.length > 0 ? enable_send_icon
                              : disable_send_icon
                        }
                        alt="#"
                        width={newMessage.length > 0 ? 30 : uploadImages.length > 0 ? 30 : 18}
                        height={newMessage.length > 0 ? 30 : uploadImages.length > 0 ? 30 : 18}
                      ></img>
                    </div>
                  </div>
                )}
              </SAColumns>
            </div>
          </div>
        )}
        {isDialogOpen && (
          <AutomatedMessagesTemplate
            setDialogOpen={setDialogOpen}
            newMessage={newMessage}
            setNewMessage={setNewMessage}
            messageUpload={messageUpload}
          />
        )}

        {gallery && (
          <ImageViewer
            setDialogOpen={setgallery}
            imageData={imageData}
            uniqueData={uniqueData}
          />
        )}
      </div>
    </>
  );
}
